<template>
  <div class="display-contents">
    <v-skeleton-loader
      class="payment-card mr-2 mb-2"
      min-width="250"
      type="card-heading, list-item-three-line"
    />
    <v-skeleton-loader
      class="payment-card mr-2 mb-2"
      min-width="250"
      type="card-heading, list-item-three-line"
    />
    <v-skeleton-loader
      class="payment-card mr-2 mb-2"
      min-width="250"
      type="card-heading, list-item-three-line"
    />
  </div>
</template>
<script>
export default {
  name: 'card-loading-skeleton'
};
</script>
<style scoped>
.payment-card {
  padding: 16px;
  border: 1px solid #eee;
  border-radius: 4px;
}
</style>
